<app-header [activeSite]="'batami'"></app-header>

<ion-content [fullscreen]="true">
    <ion-header collapse="condense">
        <ion-toolbar>
            <ion-title size="large">Batami</ion-title>
        </ion-toolbar>
    </ion-header>
    <div class="content">
        <ion-grid>
            <ion-row>
                <ion-col>
                    <app-plant-canvas *ngIf="plantData" [plantData]="plantData" [amount]="1"></app-plant-canvas>
                    <ion-card class="ion-no-margin ion-margin-vertical">
                        <ion-card-header>
                            <ion-card-title>
                                Batami XYZ
                            </ion-card-title>
                            <ion-card-subtitle>
                                Kaan & Tommy | Plant Status: {{plantData[0].healthStatus | titlecase}}
                            </ion-card-subtitle>
                        </ion-card-header>
                        <ion-card-content>
                            <ion-grid class="ion-no-padding">
                                <ion-row>
                                    <ion-col>
                                        Temperature: {{plantData[0].temperature | number:'0.0-1'}}
                                    </ion-col>
                                    <ion-col size="7">
                                        <ion-progress-bar color="primary" class="border-radius"
                                                          [value]="plantData[0].temperature / 65"></ion-progress-bar>
                                    </ion-col>
                                </ion-row>
                                <ion-row>
                                    <ion-col>
                                        Soil Humidity: {{plantData[0].soilHumidity | number:'0.0-0'}}
                                    </ion-col>
                                    <ion-col size="7">
                                        <ion-progress-bar color="secondary" class="border-radius"
                                                          [value]="plantData[0].soilHumidity / 5000"></ion-progress-bar>
                                    </ion-col>
                                </ion-row>
                                <ion-row>
                                    <ion-col>
                                        Air Humidity: {{plantData[0].airHumidity | number:'0.0-0'}} %
                                    </ion-col>
                                    <ion-col size="7">
                                        <ion-progress-bar color="tertiary" class="border-radius"
                                                          [value]="plantData[0].airHumidity / 100"></ion-progress-bar>
                                    </ion-col>
                                </ion-row>
                            </ion-grid>
                        </ion-card-content>
                    </ion-card>
                </ion-col>
            </ion-row>
            <ion-row>
                <ion-col>
                    <ion-calendar class="ion-padding border-radius"
                                  [options]="calOptions"
                                  type="string"
                                  [format]="'DD-MM-YYYY'">
                    </ion-calendar>
                </ion-col>
            </ion-row>
        </ion-grid>


    </div>

    <ion-fab vertical="bottom" horizontal="end" slot="fixed">
        <ion-fab-button>
            <ion-icon name="people"></ion-icon>
        </ion-fab-button>
        <ion-fab-list side="top">
            <ion-fab-button (click)="openChat()">
                <ion-icon name="chatbubble-ellipses"></ion-icon>
            </ion-fab-button>
            <ion-fab-button (click)="openCanvas()">
                <ion-icon name="brush"></ion-icon>
            </ion-fab-button>
        </ion-fab-list>
    </ion-fab>
</ion-content>
